import type { HoverCardContentProps, HoverCardRootProps } from '@kobalte/core/hover-card'
import type { PolymorphicProps } from '@kobalte/core/polymorphic'
import type { ParentProps, ValidComponent } from 'solid-js'
import { HoverCard as HoverCardPrimitive } from '@kobalte/core/hover-card'
import { mergeProps, splitProps } from 'solid-js'
import { cn } from '../../utils/cn.ts'

export const HoverCardTrigger = HoverCardPrimitive.Trigger

export function HoverCard(props: HoverCardRootProps) {
  const merge = mergeProps<HoverCardRootProps[]>(
    {
      gutter: 4,
      openDelay: 350,
      closeDelay: 120,
    },
    props,
  )

  return <HoverCardPrimitive {...merge} />
}

type hoverCardContentProps<T extends ValidComponent = 'div'> = ParentProps<
  HoverCardContentProps<T> & {
    class?: string
  }
>

export function HoverCardContent<T extends ValidComponent = 'div'>(props: PolymorphicProps<T, hoverCardContentProps<T>>) {
  const [local, rest] = splitProps(props as hoverCardContentProps, ['class', 'children'])

  return (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content
        class={cn(
          'z-50 w-96 rounded-xl border bg-popover p-3 text-popover-foreground shadow-md outline-none data-[expanded]:(animate-in fade-in-0 zoom-in-95) data-[closed]:(animate-out fade-out-0 zoom-out-95)',
          local.class,
        )}
        {...rest}
      >
        {local.children}
      </HoverCardPrimitive.Content>
    </HoverCardPrimitive.Portal>
  )
}
